module.exports = __webpack_public_path__ + "static/helpscout-3b11a280e3cf833747cf047907081e80.png";